import { FC, ReactNode } from 'react';
import { cva } from 'class-variance-authority';
import clsx from 'clsx';
import Container from '@/shared/ui/Container/ui/Container';

interface Props {
  className?: string;
  children?: ReactNode;
}

const Tags: FC<Props> = ({ className, children }) => {
  return (
    <Container className={clsx(cvaTags(), className)} size={'sm'}>
      {children}
    </Container>
  );
};

const cvaTags = cva([
  'Tags-cvaTags',
  'flex sm:justify-center overflow-x-scroll sm:overflow-auto sm:flex-wrap gap-0.8 pb-1',
  'text-1.6-600',
]);

export default Tags;
